import React from "react";
import "../style/Committee_members.css";
import userHoler from "../resources/user-holder.png";
import RaviSharmaImg from "../resources/ravi-sharma.jpg";
// import UdaiSharmaImg from "../resources/udai-sharma.jpg";
import SubhraKulshresthaImg from "../resources/subhra-kulshrestha.jpg";
import RaviYadavImg from "../resources/ravi-yadav.jpg";
import VandanaDabasImg from "../resources/vandana-dabas.jpg";
import AnjanaSinghImg from "../resources/anjana-singh.jpg";
import AnuragPatelImg from "../resources/anurag-patel.png";
import RMaliniImg from "../resources/r-malini.jpg";
import PriyankaMurriaImg from "../resources/priyanka-murria.jpg";
import NishuSharmaImg from "../resources/nishu-sharma.jpg";
import RichaDixitImg from "../resources/richa-dixit.jpg";
import YudhvirSinghImg from "../resources/yudhvir-singh.jpg";
import NanhaySinghImg from "../resources/nanhay-singh.jpg";
import AshwaniDhingraImg from "../resources/ashwani-dhingra.jpg";
import SubhashGChatterjeeImg from "../resources/subhash-g-chatterjee.jpg";
import RajKumarImg from "../resources/raj-kumar.jpg";
import AbhishekSharmaImg from "../resources/abhishek-sharma.jpg";
import SanjayPandeyImg from "../resources/sanjay-pandey.jpg";
import SadiaAmeenImg from "../resources/sadia-ameen.jpg";
import PriyanshBhartiImg from "../resources/priyansh-bharti.jpeg";
import JiyaChaddhaImg from "../resources/jiya-chaddha.jpg";
import PulkitChopraImg from "../resources/pulkit-chopra.jpeg";
import AkshatRathoreImg from "../resources/akshat-rathore.jpg";
import NehaChandelaImg from "../resources/neha-chandela.png";
import AnmolPavandaImg from "../resources/anmol-panvanda.png";
import NasibSinghGillImg from "../resources/nasib-singh-gill.png";
import AntimDevImg from "../resources/antim-dev-mishra.png";
import SarmisthaSarmaImg from "../resources/sarmistha-sarma.png";
import ArchanaShankarImg from "../resources/archana-shankar.png";
import RahulRishiImg from "../resources/rahul-rishi.png";
import RajivGaurImg from "../resources/rajiv-gaur.png";
import PreetiGuliaImg from "../resources/preet-gulia.png";
import MonikaAggrwalImg from "../resources/monika-aggarwal.png";
import ChandraMohanSinghImg from "../resources/chandra-mohan-singh.jpg";
import UdaiSharmaImg from "../resources/udai-sharma.jpg";
import MNHodaImg from "../resources/mn-hoda.jpg";

const memberImages = {
  "Mr. Ravi Sharma": RaviSharmaImg,
  "Shri. Ravi Sharma": RaviSharmaImg,
  "Mr. Udai Sharma": UdaiSharmaImg,
  "Prof. (Dr.) Subhra Kulshrestha": SubhraKulshresthaImg,
  "Mr. Ravi Yadav": RaviYadavImg,
  "Dr. Vandana Dabas": VandanaDabasImg,
  "Prof. (Dr.) Anjana Singh": AnjanaSinghImg,
  "Mr. Anurag Patel": AnuragPatelImg,
  "Dr. R. Malini": RMaliniImg,
  "Prof. (Dr.) Priyanka Murria": PriyankaMurriaImg,
  "Dr. Nishu Sharma": NishuSharmaImg,
  // Images intentionally not shown for technical support and transport members
  "Ms. Richa Dixit": RichaDixitImg,
  "Prof. (Dr.) Yudhvir Singh": YudhvirSinghImg,
  "Prof. (Dr.) Nanhey Singh": NanhaySinghImg,
  "Prof. (Dr.) Ashwani Dhingra": AshwaniDhingraImg,
  "Dr. Subhash G Chatterjee": SubhashGChatterjeeImg,
  "Dr. Raj Kumar Yadav": RajKumarImg,
  "Mr. Abhishek Sharma": AbhishekSharmaImg,
  "Dr. Sanjay Pandey": SanjayPandeyImg,
  "Dr. Sadia Ameen": SadiaAmeenImg,
  "Mr. Priyansh Bharti": PriyanshBhartiImg,
  "Mr. Pulkit Chopra": PulkitChopraImg,
  "Ms. Jiya Chaddha": JiyaChaddhaImg,
  "Mr. Akshat Rathore": AkshatRathoreImg,
  "Ms. Neha Chandela": NehaChandelaImg,
  "Mr. Anmol Panvanda": AnmolPavandaImg,
  "Prof. (Dr.) Nasib Singh Gill": NasibSinghGillImg,
  "Dr. Antim Dev": AntimDevImg,
  "Dr. Sarmistha Sarma": SarmisthaSarmaImg,
  "Dr. Archana Shankar": ArchanaShankarImg,
  "Prof. (Dr.) Rahul Rishi": RahulRishiImg,
  "Mr. Rajiv Gaur": RajivGaurImg,
  "Dr. Preeti Gulia": PreetiGuliaImg,
  "Dr. Monika Aggrawal": MonikaAggrwalImg,
  "Dr. Chandra Mohan Singh": ChandraMohanSinghImg,
  "Prof.(Dr.) M.N. Hoda": MNHodaImg,
};

function CommitteeMemberDetails({ category }) {
  const committeeMembers = {
    "chief-patron": [
      { name: "Shri. Ravi Sharma", title: "CHIEF PATRON" },
    ],
    patron: [
      { name: "Mr. Udai Sharma", title: "PATRON" },
    ],
    "conference-advisory-board": [
      {
        name: "Dr. Sanjay Pandey",
        title: "Conference Advisory Board",
        bio: "Vodafone National Head, Australia.",
      },
      {
        name: "Mr. Abhishek Sharma",
        title: "Conference Advisory Board",
        bio: "Portfolio Manager, Lockton, Australia.",
      },
      {
        name: "Prof. (Dr.) Nasib Singh Gill",
        title: "Conference Advisory Board",
        bio: "Senior Professor, Department of Computer Science & Applications, MDU, Rohtak.",
      },
      {
        name: "Prof. (Dr.) Yudhvir Singh",
        title: "Conference Advisory Board",
        bio: "Director, Pt DDU Centre for Skill & Vocational Education, MDU, Rohtak.",
      },
      {
        name: "Prof. (Dr.) Rahul Rishi",
        title: "Conference Advisory Board",
        bio: "Controller of Examination, MDU, Rohtak.",
      },
      {
        name: "Prof.(Dr.) M.N. Hoda",
        title: "Conference Advisory Board",
        bio: "Director, Bharti Vidyapeeth Institute of Computer Applications and Management (BVICAM)",
      },
      {
        name: "Dr. Chandra Mohan Singh",
        title: "Conference Advisory Board",
        bio: "Registrar, IITM Group of Institutions.",
      },
      {
        name: "Dr. Sarmistha Sarma",
        title: "Conference Advisory Board",
        bio: "Professor, Asian Business School, Noida.",
      },
      {
        name: "Dr. Subhash G Chatterjee",
        title: "Conference Advisory Board",
        bio: "Associate Professor, Bharti Vidyapeeth University, Pune.",
      },
      {
        name: "Dr. Monika Aggrawal",
        title: "Conference Advisory Board",
        bio: "Assistant Professor, MAIT, New Delhi.",
      },
    ],
    convenor: [
      { name: "Prof. (Dr.) Anjana Singh", title: "CONVENOR" },
      { name: "Dr. Vandana Dabas", title: "CONVENOR" },
    ],
    "co-convenor": [
      { name: "Prof. (Dr.) Subhra Kulshrestha", title: "CO-CONVENOR" },
      { name: "Prof. (Dr.) Priyanka Murria", title: "CO-CONVENOR" },
    ],
    speakers: [
      {
        name: "Dr. Archana Shankar",
        title: "SPEAKER",
        bio: "Deputy Associate Dean and Head of Department, Northumbia University, London.",
      },
      {
        name: "Dr. Sadia Ameen",
        title: "SPEAKER",
        bio: "Associate Professor, Department of Bio-Convergence Science, Jeonbuk National University, 56212, Republic of Korea.",
      },
      {
        name: "Prof. (Dr.) Nasib Singh Gill",
        title: "SPEAKER",
        bio: "Senior Professor, Department of Computer Science & Applications, MDU, Rohtak.",
      },
      {
        name: "Prof. (Dr.) Yudhvir Singh",
        title: "SPEAKER",
        bio: "Director, Pt DDU Centre for Skill & Vocational Education, MDU, Rohtak.",
      },
      {
        name: "Mr. Abhishek Sharma",
        title: "SPEAKER",
        bio: "Portfolio Manager, Lockton, Australia.",
      },
      {
        name: "Prof. (Dr.) Ashwani Dhingra",
        title: "SPEAKER",
        bio: "Director, UIET, MDU, Rohtak.",
      },
      {
        name: "Dr. Preeti Gulia",
        title: "SPEAKER",
        bio: "HOD, Dept. of Computer Science & Applications, MDU, Rohtak.",
      },
      {
        name: "Dr. Raj Kumar Yadav",
        title: "SPEAKER",
        bio: "Associate Professor, UIET, MDU, Rohtak.",
      },
      {
        name: "Prof. (Dr.) Nanhey Singh",
        title: "SPEAKER",
        bio: "Professor, Netaji Subhas University of Technology, New Delhi.",
      },
    ],
    "technical-support": [
      { name: "Mr. Umanshu", title: "TECHNICAL SUPPORT" },
      { name: "Mr. Nand Kishore", title: "TECHNICAL SUPPORT" },
    ],
    "logistics-and-transport": [
      { name: "Mr. Bansharaj Yadav", title: "LOGISTICS AND TRANSPORT" },
      { name: "Mr. Prakhar Aditya", title: "LOGISTICS AND TRANSPORT" },
    ],
    "organizing-committee": [
      { name: "Dr. Antim Dev", title: "ORGANIZING COMMITTEE" },
      { name: "Dr. Nishu Sharma", title: "ORGANIZING COMMITTEE" },
      { name: "Mr. Rajiv Gaur", title: "ORGANIZING COMMITTEE" },
      { name: "Ms. Richa Dixit", title: "ORGANIZING COMMITTEE" },
      { name: "Mr. Anurag Patel", title: "ORGANIZING COMMITTEE" },
      { name: "Mr. Anmol Panvanda", title: "ORGANIZING COMMITTEE" },
      { name: "Ms. Neha Chandela", title: "ORGANIZING COMMITTEE" },
      { name: "Mr. Ravi Yadav", title: "ORGANIZING COMMITTEE" },
    ],
    "student-coordinators": [
      { name: "Mr. Priyansh Bharti", title: "STUDENT COORDINATOR" },
      { name: "Mr. Akshat Rathore", title: "STUDENT COORDINATOR" },
      { name: "Ms. Jiya Chaddha", title: "STUDENT COORDINATOR" },
      { name: "Mr. Pulkit Chopra", title: "STUDENT COORDINATOR" },
    ],
  };

  const members = committeeMembers[category] || [];
  const categoryLabel =
    category === "co-convenor"
      ? "Co-Convenor"
      : category
          .split("-")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");

  return (
    <div className="committee-details-container">
      <h2 className="committee-category-title">{categoryLabel}</h2>
      <div className="committee-members-grid">
        {members.map((member, index) => (
          <div key={index} className="member-card">
            {!["technical-support", "logistics-and-transport"].includes(category) && (
              <div className="member-image-container">
                <img
                  src={member.image || memberImages[member.name] || userHoler}
                  alt={member.name}
                  className="member-image"
                />
              </div>
            )}
            <div className="member-info">
              <p className="member-title">{member.title || categoryLabel}</p>
              <h3 className="member-name">{member.name}</h3>
              {member.bio && <p className="member-bio">{member.bio}</p>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CommitteeMemberDetails;
